import React from 'react';
import connect from 'react-redux/lib/connect/connect';

const Spinner = (props) => {
    const loading = props.loading;
    // console.log('------------------------',loading);
    return (
        <div data-v-623d66c4="" className="loading-back" style={{ display: loading ? "flex" : "none" }}>
            {/* <i data-v-e56d064c="" data-v-ee85aa0c="" className="fa-lg fa-regular fa-spinner rotate"  style={{margin: "auto"}}></i> */}
            <img className=" " src="../images/logo.png" alt="" style={{width: "200px"}}/>
        </div>
    );
};

const mapStateToProps = state =>({
    loading: state.page.loading
});

export default connect( mapStateToProps )(Spinner);


// WEBPACK FOOTER //
// ./src/containers/Spinner.js